import { CommonFlag, type CommonFlagProps, type CommonFlagAction } from '../index';

export type FlagProps = CommonFlagProps & {
	packageName?: string;
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default CommonFlag;
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { CommonFlagAction };
